// extracted by mini-css-extract-plugin
export default {"signalTable":"SignalsTable_signalTable__DNLDp","flex":"SignalsTable_flex__7zmpA"};